module.exports = __webpack_public_path__ + "static/media/cover.66871260.jpeg";